import { createAction } from 'redux-actions';

export const startSearchByLocationSubmit = createAction('START_SEARCH_BY_LOCATION_SUBMIT');

export const resolveSearchByLocationSubmit = createAction('RESOLVE_SEARCH_BY_LOCATION_SUBMIT');
